module.exports = __webpack_public_path__ + "img/sponsorV12.82a5247e.png";